import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Params from "../../config/Params";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import SyncLoader from "react-spinners/SyncLoader";
import useParams from "../../config/useParams";

export default function Reports() {
  const windowHeight = useRef(window.innerHeight);
  console.log(windowHeight, "windowHeight");

  const [params] = useParams()

  const [maxMark, setMaxMark] = useState("");
  const [report, setReport] = useState("");
  const [loading, setLoading] = useState(false);
  const [pdf, setPdf] = useState("");
  const [openMode, setOpenMode] = useState(false);
  const [errors, setError] = useState({});
  const [gradename, setGradeName] = useState([]);
  const [evalution, setEvaluation] = useState([]);
  const [students, setStudents] = useState([]);
  const [studId, setStudId] = useState("");
  const [formData, setFormData] = useState({
    duration: "",
    maxMark: "",
    classname: "",
    division_id: "",
    class_id: "",
    gradingName: "",
    gradingId: "",
    grading: "",
    student_id: "",
    students: "",
  });
  console.log(formData.student_id, "formData.student_id");

  const { t } = useTranslation();
  const navic = useNavigate();
  useEffect(() => {
    AcademicYesrList();
    ClassList();
  }, [params]);
  const [ReportErrors, setReportErrors] = useState({});
  const validateReportAPI = () => {
    let tempErrors = {};
    if (!formData.gradingName) {
      tempErrors.gradingName = 'Please select year.';
    }
    if (!formData.classname) {
      tempErrors.classname = 'Please select grade.';
    }
    if (!formData.students) {
      tempErrors.students = 'Please select student.'
    }

    return tempErrors
  }

  const createReportData = () => {

    const validationError = validateReportAPI();
    const isError = Object.keys(validationError).length > 0;
    if (isError) {
      setError(validationError);
      console.log('validationError--', validationError)
      return;
    }
    setLoading(true);
    let newRequestBody = JSON.stringify({
      api_key: params.api_key,
      customer_id: params.customer_id,
      teacher_id: params.teacher_id,
      academic_year_id: formData.gradingId,
      student_id: studId,
      class_id: formData.division_id,
      format: "pdf",
    });
    simplePostCall(ApiConfig.STUDENTS_REPORT, newRequestBody)
      .then((data) => {
        if (data.result) {
          setPdf(data.file_path);
          setReport(data.result);
          setLoading(false);
          setOpenMode(true);
        } else {
          toast.error(data?.message);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("api response", error);
      }).finally(() => {
        setLoading(false);
      })
  };
  const AcademicYesrList = () => {
    let newRequestBody = JSON.stringify({
      api_key: params.api_key,
      customer_id: params.customer_id,
    });
    simplePostCall(ApiConfig.ACADEMIC_YEAR_LIST, newRequestBody)
      .then((data) => {
        console.log(data, "garding Appi");
        if (data.data) {
          var gradelists = [];
          data.data.map((grades) => {
            gradelists.push({
              label: grades.academic_year_name,
              value: grades.academic_year_id,
              ...grades,
            });
          });

          let indx = data.data?.findIndex((i) => {
            return i?.academic_year_status === 'current'
          })

          if (indx != -1) {

            console.log(data.data[indx], "Amir");

            onAcademicChange({
              label: data.data[indx]?.academic_year_name,
              value: data.data[indx]?.academic_year_id,
              ...data.data[indx]
            })


          }



          setGradeName({ ...gradename, gradelists: gradelists });
        }
      })
      .catch((error) => {
        console.log("api response", error);
      });
  };
  function onAcademicChange(grading) {
    console.log(grading, "grading");
    if (formData.gradingName?.value !== grading.value) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        gradingName: grading,
        gradingId: grading.academic_year_id,
      }));
    }
  }
  const ClassList = () => {
    let newRequestBody = JSON.stringify({
      api_key: params.api_key,
      customer_id: params.customer_id,
      user_id: params.teacher_id,
    });
    simplePostCall(ApiConfig.CLASSES_LIST_API, newRequestBody)
      .then((data) => {
        console.log(data, "Evalution Data");
        if (data.result) {
          var evaluationList = [];
          data.list?.map((grades) => {
            console.log(grades, "grades");

            evaluationList.push({
              label: grades.class_name + "-" + grades.class_division_name,
              value: grades.class_division_id,
              class_id: grades.class_id,
              ...grades,
            });
          });
          setEvaluation({ ...evalution, evaluationList: evaluationList });
        } else {
          toast.error(data.message);
        }
      })
      .catch((err) => {
        console.log("api res fail", err);
      });
  };
  function onEvaluatuionChange(clsid) {
    setFormData((prevFormData) => ({
      ...prevFormData,
      classname: clsid,
      division_id: clsid.class_division_id,
      class_id: clsid.class_id,
      students: "",
    }));
    StudentsList(clsid);
  }
  const onStudentChange = (stuid) => {
    console.log(stuid, "stuid");

    setFormData((prevFormData) => ({
      ...prevFormData,
      students: stuid,
      student_id: stuid.student_id,
    }));
    setStudId(stuid.student_id);
  };
  const StudentsList = (classnew) => {
    console.log(classnew, "classnew");
    let newRequestBody = JSON.stringify({
      api_key: params.api_key,
      customer_id: params.customer_id,
      user_id: params.teacher_id,
      class_id: classnew.class_id,
      section_id: classnew.value,
    });
    simplePostCall(ApiConfig.STUDENT_LIST_IN_STUDENTMANAG, newRequestBody)
      .then((data) => {
        console.log(data, "students Data");
        if (data.result) {
          var evaluationList = [];
          data.data?.map((grades) => {
            evaluationList.push({
              label: grades.student_name,
              value: grades.student_id,
              class_id: grades.class_id,
              ...grades,
            });
          });
          setStudents({ ...evalution, evaluationList: evaluationList });
        } else {
          toast.error(data.message);
        }
      })
      .catch((err) => {
        console.log("api res fail", err);
      });
  };

  const OnLoading = () => {
    createReportData();


    // setTimeout(() => {
    //   setOpenMode(true);
    // }, 3000);
  };
  return (
    <div>
      <div className="main-sectionn ">
        <div className="col-md-12">
          <div className="announcementCreatee">
            <label className="edit-head">{t("Reports")}</label>
          </div>
        </div>
        <div className="form-row">
          <div className="col-md-12 row">
            <div className="form-group col-md-12">
              <label for="task-title">{t("Academic Year")}</label>
              <Select
                class="js-example-basic-single form-select"
                name="gradingName"
                value={formData.gradingName}
                onChange={onAcademicChange}
                options={gradename.gradelists}
                styles={{
                  control: (baseStyles) => ({
                    ...baseStyles,
                    borderColor: errors.terms ? "red" : "#ced4da",
                  }),
                }}
              />
              {errors.gradingName && !formData.gradingName ? (
                <p className="val-form">{errors.gradingName}</p>
              ) : null}
            </div>
          
            <div className="form-group col-md-12">
              <label for="task-title">{t("Grade")}</label>
              <Select
                class="js-example-basic-single form-select"
                name="gradingName"
                value={formData.classname}
                onChange={onEvaluatuionChange}
                options={evalution.evaluationList}
                styles={{
                  control: (baseStyles) => ({
                    ...baseStyles,
                    borderColor: errors.terms ? "red" : "#ced4da",
                  }),
                }}
              />

              {errors.classname && !formData.classname ? (
                <p className="val-form">{errors.classname}</p>
              ) : null}
            </div>

            <div className="form-group col-md-12">
              <label for="task-title">{t("Student")}</label>

              <Select
                class="js-example-basic-single form-select"
                name="gradingName"
                value={formData.students}
                onChange={onStudentChange}
                options={students.evaluationList}
                styles={{
                  control: (baseStyles) => ({
                    ...baseStyles,
                    borderColor: errors.terms ? "red" : "#ced4da",
                  }),
                }}
              />
              {errors.students && !formData.students ? (
                <p className="val-form">{errors.students}</p>
              ) : null}
            </div>
          </div>
          <div className="create-but-1">
            <button
              className="btn btn-primary  crbt"
              type="button"
              onClick={() => OnLoading()}
            >
              {loading ? (
                <SyncLoader color="white" size={13} />
              ) : (
                t("View Report")
              )}
            </button>
          </div>
        </div>
      </div>
      <Modal
        size="xl"
        centered
        show={openMode}
        onHide={() => [setLoading(false), setOpenMode(false)]}
        animation={true}
      >
        <Modal.Header closeButton={true}>
          <Modal.Title>{t("Reports of Students")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="borderModal"></div>

          <div
            style={{
              display: "flex",
              height: `${windowHeight.current - 242}px`,
            }}
            className="borderModalBelow"
          >
            <iframe style={{ flex: 1, width: "100%" }} src={pdf} />
          </div>
        </Modal.Body>
        <div className="borderModal"></div>
        <Modal.Footer>
          <div className="modalBtns">
            <button
              className="cancelBtn"
              onClick={() => [setLoading(false), setOpenMode(false)]}
            >
              {t("Cancel")}
            </button>
            {/* <button className="YesBtn" onClick={() => [setOpenMode(false)]}>
              Delete
            </button> */}
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
